import { router } from '@inertiajs/react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { CheckCircle } from 'lucide-react'

interface RegistrationSuccessProps {
  patient_name?: string
}

export default function RegistrationSuccess({ patient_name }: RegistrationSuccessProps) {
  const handleLoginRedirect = () => {
    router.visit('/login')
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-2xl">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <CheckCircle className="w-16 h-16 text-green-500" />
          </div>
          <CardTitle className="text-2xl">Registration Successful!</CardTitle>
          <CardDescription>
            {patient_name ? `Welcome, ${patient_name}!` : 'Welcome to our care program!'}
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          <div className="bg-muted rounded-lg p-4">
            <h3 className="font-semibold mb-2">What happens next?</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex items-start">
                <span className="mr-2">1.</span>
                <span>Our care team will review your risk assessment and contact you within 1-2 business days</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">2.</span>
                <span>You'll receive a text message or phone call to schedule your first appointment</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">3.</span>
                <span>You can now log in to your patient portal to view your care progress</span>
              </li>
            </ul>
          </div>

          <div className="border-t pt-4">
            <h3 className="font-semibold mb-2">Access Your Patient Portal</h3>
            <p className="text-sm text-muted-foreground mb-4">
              You can log in to track your treatment progress, view test results, and communicate with your care team.
            </p>
            <Button onClick={handleLoginRedirect} className="w-full">
              Go to Login Page
            </Button>
          </div>

          <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4">
            <h3 className="font-semibold text-amber-900 dark:text-amber-100 mb-2">Important Reminder</h3>
            <p className="text-sm text-amber-800 dark:text-amber-200">
              If you have an urgent medical concern, please call 911 or visit your nearest emergency room.
              The patient portal is not monitored 24/7 and should not be used for emergencies.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
